import { combineLatest, take } from 'rxjs';

import * as fromRoot from '../../../reducers';
import * as cobrandInfo from '../../../actions/cobrand-info/cobrand-info.actions';
import { FeatureFlagsService } from './feature-flags.service';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FeatureFlagDictionaryEnum } from 'src/app/shared/enums';

@Injectable({
  providedIn: 'root'
})
export class CobrandFacadeService {
  private readonly store = inject(Store);
  private readonly featureFlagsService = inject(FeatureFlagsService);

  validateCobrandInfoAndDispatch(): void {
      combineLatest([
        this.store.select(fromRoot.getContentCobrandInfo),
        this.store.select(fromRoot.getVdsId) 
      ])
      .pipe(take(1))
      .subscribe(([coBrandInfoData, accountData]) => {  
        if (!accountData || coBrandInfoData) {
            return;
        }
        const flags = this.featureFlagsService.snapshot;        
        if (flags?.[FeatureFlagDictionaryEnum.ENABLE_COBRAND_NEW_PROGRAM_PROMPTS]) {
            this.store.dispatch(new cobrandInfo.GetCobrandInfo({ accountId: accountData }));
        } else {
            this.store.dispatch(new cobrandInfo.SkipCobrandInfo());
        }
      });
    }
}